export enum Title {
    VITA_STUDENT = 'Vita Student',
    HOUSE_OF_SOCIAL = 'House of Social',
}
